import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

import type * as imports from './lazyIndex';
import type { GroupHeaderProps } from './components/GroupHeader';

const lazyModule: LazyModule<typeof imports> = new LazyModule<typeof imports>(
    () => import(/* webpackChunkName: "GroupHeader" */ './lazyIndex'),
    { name: 'GroupHeader' }
);

export const GroupHeader: LazyComponent<GroupHeaderProps, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.GroupHeader
);
